import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
//import {Panel} from 'primereact/panel';
import {Dropdown} from 'primereact/dropdown';
import {Calendar} from 'primereact/calendar';
import {InputSwitch} from 'primereact/inputswitch';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';    
import moment from 'moment';
import {Toast} from 'primereact/toast';
import Messages from '../../../shared/UI/Messages/Messages';
import { ToggleButton } from 'primereact/togglebutton';
import {  DROPDOWN_CONFIG, PROJECT_SUBMENU_ID } from '../../../shared/Config';
import { HASACCESS, TIME_DURATION, REDIRECT_TO_URL } from '../../../shared/utility';
import * as actions from '../../../store/actions/index';

class Project extends Component {
    state = {
        display : true,
        type : 'add',
        // projectid:'',
        projectnumber:'',
        projectdesc:'',
        headertext:'',
        itemdesc:'',
        isactive:'',
        ownerorg:'',
        customer:'',
        billable:'',
        ponumber:'',
        contractnumber:'',
        accountmanager:'',
        projectmanager:'',
        startdate:'',
        enddate:'',
        value:'',
        classification:'',
        allowcharging:'',
        chargeableorg:'',
        workforcerequired:'',
        allowedvendorforworkforce:'',
    }


    componentDidMount(){       
        
        this.props.getMasterTableList('Employee/GetProjectList');   
        this.props.getMasterKeywordList('Vendor'); 
        this.props.getMasterKeywordList('Customer');
        this.props.getMasterKeywordList('Employee');
        this.props.getMasterKeywordList('OrgUnit');
        // setTimeout(()=>{  this.props.getMasterKeywordList('OrgUnit'); },3000)
        // setTimeout(()=>{  this.props.getMasterKeywordList('Employee'); },4000)

        this.getAccess = HASACCESS(PROJECT_SUBMENU_ID);

        let type = this.props.match.params.type;
        if(type !== 'add'){
            setTimeout(() => {
                this.fetchSingleProcess();
            },1000)
        }
    }


    fetchSingleProcess = () =>{
   
        let id = this.props.match.params.id;   
        let type = this.props.match.params.type;
        let storageItems = [];

        if(this.props.tableLists && this.props.tableLists.length > 0) {
            storageItems = this.props.tableLists;
        }
        if(storageItems){
            let filterData = storageItems.filter(list => {
                return list.projectid ===id;
            }).reduce((arr,el) => {
                return el;
            },{});
       
          
            
            if(filterData){
                var data = {
                    type:type,
                    projectid:filterData.projectid,
                    projectnumber: filterData.projectnumber,
                    projectdesc: filterData.projectdesc,
                    headertext: filterData.headertext,
                    itemdesc: filterData.itemdesc,
                    isactive: filterData.isactive,
                    ownerorg: filterData.ownerorg,
                    customer: filterData.customer,
                    billable: filterData.billable,
                    ponumber: filterData.ponumber,
                    contractnumber: filterData.contractnumber,
                    accountmanager: filterData.accountmanager,
                    projectmanager : filterData.projectmanager,
                    startdate: filterData.startdate ? new Date(filterData.startdate) : null,
                    enddate:filterData.enddate ? new Date(filterData.enddate) : null,
                    value: filterData.value,
                    classification: filterData.classification,
                    allowcharging: filterData.allowcharging,
                    chargeableorg: filterData.chargeableorg,
                    workforcerequired: filterData.workforcerequired,
                    allowedvendorforworkforce: filterData.allowedvendorforworkforce



                }
                this.setState(data);
                
            }
        }

    }


    actionTemplate = (rowData, column) => {
        let rowIndex = column.rowIndex;
        return <div>
            <Button type="button" icon="pi pi-trash" className="p-button-danger" onClick={() => this.removeField(rowIndex)} ></Button>
        </div>;
    }

  
    add = () => {


        
        let data = {
            //Projectid:null,
            Projectnumber:this.state.projectnumber,
            Projectdesc:this.state.projectdesc,
            Headertext:this.state.headertext,
            Itemdesc:this.state.itemdesc,
            Isactive:this.state.isactive,
            Ownerorg:this.state.ownerorg,
            Customer:this.state.customer,
            Billable:this.state.billable,
            Ponumber:this.state.ponumber,
            Contractnumber:this.state.contractnumber,
            Accountmanager:this.state.accountmanager,
            Projectmanager:this.state.projectmanager,
            Startdate:this.state.startdate,
            Enddate:this.state.enddate,
            Value:this.state.value,
            Classification:this.state.classification,
            Allowcharging:this.state.allowcharging,
            Chargeableorg:this.state.chargeableorg,
            Workforcerequired:this.state.workforcerequired,
            Allowedvendorforworkforce:this.state.allowedvendorforworkforce
        }
        

        if(this.state.type === 'edit'){
            data.projectid = this.state.projectid;
            data.projectid = this.props.match.params.id;
        }

        this.props.processDynamicData('Project',this.state.type,data,'Employee/GetProjectList');
        

    }

    resetData = () => {
        // Reset the state to its initial values
        this.setState({
            display : true,
            type : 'add',
            // projectid:'',
            projectnumber:'',
            projectdesc:'',
            headertext:'',
            itemdesc:'',
            isactive:'',
            ownerorg:'',
            customer:'',
            billable:'',
            ponumber:'',
            contractnumber:'',
            accountmanager:'',
            projectmanager:'',
            startdate:'',
            enddate:'',
            value:'',
            classification:'',
            allowcharging:'',
            chargeableorg:'',
            workforcerequired:'',
            allowedvendorforworkforce:''
        });
    }
   

    inputTextEditor = (props, field) => {
        return <InputText type="text" value={props.rowData[field]} onChange={(e) => this.onEditorValueChange(props, e.target.value)} />;
    }


    removeField  = (removeIndex) => {

        const updatedDeptValue = this.state.rows.filter((value,index) => {
            return removeIndex !== index;
        })
        this.setState({rows:updatedDeptValue})

    }

    Change = (e) => {
        let {name, value} = e.target;
        this.setState({[name]:value,touch:true})

        // setTimeout(() => {
        //     this.checkDuration();
        // },2000)
        
        
    }




    render() {   

        if(this.props.success){
            REDIRECT_TO_URL('/Project/',this.props);
        }

        let addAccess = true;
        let editAccess = true;
        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess};
        let isEnabled = (this.state.touch === true);

        //let isEnabled = (this.state.shiftCategory!==null && this.state.shiftName!=='' && this.state.ShiftId!=='' && this.state.Description!=='');
        return (
            <div className="p-grid ">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Project</h1>
           
                        <div className="p-grid mt2">
                           
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Project Number <span className="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="projectnumber" value={this.state.projectnumber} placeholder="Project Number" onChange={this.Change} /></div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Project Descripition <span className="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="projectdesc" value={this.state.projectdesc}  placeholder="Project Descripition"  onChange={this.Change}/></div>                                
                            </div>
                            {/* <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Project Descripition <span className="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="Description" placeholder="Project Descripition" value={this.state.Description}  onChange={this.Change}/></div>                                
                            </div> */}
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Header Text <span className="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="headertext" placeholder="Header Text" value={this.state.headertext}  onChange={this.Change}/></div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Item Descripition <span className="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="itemdesc" placeholder="Item Descripition" value={this.state.itemdesc}  onChange={this.Change}/></div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">IsActive <span className="requiredColor">*</span></label>
                                <div className="mt1"><ToggleButton checked={this.state.isactive} onChange={(e) => this.setState({isactive: e.value})} onIcon="pi pi-check" offIcon="pi pi-times" /></div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Owner Organization <span className="requiredColor">*</span></label>
                                <div className="mt1"></div>
                                <Dropdown className="p-col-12" placeholder="Select Owrnerorg" options={this.props.Department} value={this.state.ownerorg} 
                            onChange={e => this.Change(e)}  name="ownerorg" {...DROPDOWN_CONFIG} />
                            </div>
                            
                            <div className="p-col-12 p-md-6 p-lg-6">
                            <label className="label">Customer <span className="requiredColor">*</span></label>  
                            <div className="mt1"></div>
                            <Dropdown className="p-col-12" placeholder="Select Customer" options={this.props.Customer} value={this.state.customer} 
                            onChange={this.Change} name="Customer" {...DROPDOWN_CONFIG} />
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Billable <span className="requiredColor">*</span></label>
                                <div className="mt1"><ToggleButton checked={this.state.billable} onChange={(e) => this.setState({billable: e.value})} onIcon="pi pi-check" offIcon="pi pi-times" /></div>                              
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Purchase order <span className="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="ponumber" placeholder="Purchase order" value={this.state.ponumber}  onChange={this.Change}/></div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Contract Number <span className="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="contractnumber" placeholder="Contract Number" value={this.state.contractnumber}  onChange={this.Change}/></div>                                
                            </div>


                            <div className="p-col-12 p-md-6 p-lg-6">
                            <label className="label">Account Manager <span className="requiredColor">*</span></label>  
                            <div className="mt1"></div>
                            <Dropdown className="p-col-12" placeholder="Select Account manager" options={this.props.projectmanager} value={this.state.accountmanager} 
                            onChange={e => this.Change(e)}  name="accountmanager" {...DROPDOWN_CONFIG} />
                            </div>



                            <div className="p-col-12 p-md-6 p-lg-6">
                            <label className="label">Project Manager <span className="requiredColor">*</span></label>  
                            <div className="mt1"></div>
                            <Dropdown className="p-col-12" placeholder="Select Project Manager" options={this.props.projectmanager} value={this.state.projectmanager} 
                            onChange={e => this.Change(e)}  name="projectmanager" {...DROPDOWN_CONFIG} />
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Start Date <span className="requiredColor">*</span></label>
                                <div className="mt1"><Calendar className="p-col-12" name="startdate" placeholder="Start Date " value={this.state.startdate}  onChange={this.Change}/></div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">End Date <span className="requiredColor">*</span></label>
                                <div className="mt1"><Calendar className="p-col-12" name="enddate" placeholder="End Date " value={this.state.enddate}  onChange={this.Change}/></div>                              
                            </div>
                              <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Value <span className="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="value" placeholder="Value" value={this.state.value}  onChange={this.Change}/></div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Classification<span className="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="classification" placeholder="Classification" value={this.state.classification}  onChange={this.Change}/></div>                                
                            </div>
                            

                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Allow Charging <span className="requiredColor">*</span></label>
                                <div className="mt1"><ToggleButton checked={this.state.allowcharging} onChange={(e) => this.setState({allowcharging: e.value})} onIcon="pi pi-check" offIcon="pi pi-times" /></div>                              
                            </div>




                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Chargeable Department <span className="requiredColor">*</span></label>
                                <div className="mt1"></div>
                                <Dropdown className="p-col-12" placeholder="Select Chargeableorg" options={this.props.Department} value={this.state.chargeableorg} 
                            onChange={e => this.Change(e)}  name="chargeableorg" {...DROPDOWN_CONFIG} />
                            </div>


                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Work Force Required <span className="requiredColor">*</span></label>
                                <div className="mt1"><ToggleButton checked={this.state.workforcerequired} onChange={(e) => this.setState({workforcerequired: e.value})} onIcon="pi pi-check" offIcon="pi pi-times" /></div>                              
                            </div>
        
                            <div className="p-col-12 p-md-6 p-lg-6">
                            <label className="label">Vendor <span className="requiredColor">*</span></label>  
                            <div className="mt1"></div>
                            <Dropdown className="p-col-12" placeholder="Select Vendor" options={this.props.Vendor} value={this.state.allowedvendorforworkforce} 
                            onChange={e => this.Change(e)}  name="allowedvendorforworkforce" {...DROPDOWN_CONFIG} />
                            </div>
                           
                            
                            <div className="p-col-12 p-lg-12">
                                <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData}  to={"/Project"} />
                            </div>
                            
                           
                        </div> 
                           
           
                       
                    </div>
                         
                </div>
                
            </div>
        );
    }
}


const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        userDetail : state.auth.userDetail,
        userPref : state.auth.userPref,
        loading : state.master.loading,
        error : state.master.error,
        success : state.master.success,
        tableLists : state.master.tableLists,
        Vendor: (state.keyword.Vendor!==undefined) ? state.keyword.Vendor : [],
        Customer: (state.keyword.Customer!==undefined) ? state.keyword.Customer : [],
        // ownerorg: (state.keyword.ownerorg!==undefined) ? state.keyword.ownerorg : [],
        projectmanager: (state.keyword.Employee!==undefined) ? state.keyword.Employee : [],
        // Accountmanager: (state.keyword.Employee!==undefined) ? state.keyword.Employee : [],
        Department: (state.keyword.OrgUnit!==undefined) ? state.keyword.OrgUnit : []

       // OrgUnit: (state.keyword.OrgUnit!==undefined) ? state.keyword.OrgUnit : [],
       // Employee: (state.keyword.Employee!==undefined) ? state.keyword.Employee : [],
        
    }
}

const mapDispatchToProps = dispatch => {
    return {
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value))
    }
}
  
export default connect(mapStateToProps,mapDispatchToProps)(Project);